/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFastForward = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 3v18l9-7.364V21l11-9-11-9v7.364zm11 4 6 5-6 5zM4 7l6 5-6 5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFastForward as FastForward };
